mutation deleteAssignmentProposal(
  $scenarioId: ID!
  $originId: ID!
  $linkId: ID!
  $proposalId: ID!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    deleteAssignmentProposal(linkId: $linkId, proposalId: $proposalId) {
      deleted
      errorCode
      __typename
    }
    __typename
  }
}
